const addListener = function(el, type, fn)
{
    el.addEventListener(type, fn, false);
};
const numFormat = function(el){
    addListener(el, "blur", () =>
    {
        if (!el.value)
        {
            return;
        }
        let val = el.value;
        val = val.toString().replace(/\$|\,/g, "");
        if (isNaN(val))
        {
            val = "0";
        }
        // eslint-disable-next-line eqeqeq
        let sign = (val == (val = Math.abs(val)));
        val = Math.floor(val * 100 + 0.50000000001);
        let cents = val % 100;
        val = Math.floor(val / 100).toString();
        if (cents < 10)
        {
            cents = "0" + cents;
        }
        for (let i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++)
        {
            val = val.substring(0, val.length - (4 * i + 3)) + "," + val.substring(val.length - (4 * i + 3));
        }
        el.value = (((sign) ? "" : "-") + val + "." + cents);
    });
};
export default{
    bind(el,binding){
        if (el.tagName.toLowerCase() !== "input")
        {
            el = el.getElementsByTagName("input")[0];
        }
        // spaceFilter(value);
        switch (binding.arg){
            case "num":
                numFormat(el);
                break;
        }
    }
};